import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';

import TowerAPI from '../../api/TowerAPI';
import FieldText from '../common/FieldText';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import TowerController from '../../controller/TowerController';
import ApiUiController from '../../controller/ApiUiController';

class TowerPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).tower_details;
    this.tower = TowerController.addModel(this.model.fields);
    this.tower.project_id = props.project.id;
    this.tower.is_project_tower = 1;
    this.tower.id = 0;
    this.state = { inValid: {}, inApiCall: false, tower: { ...this.tower, auto: 4 } };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props && props.tower && props.tower.id !== this.state.tower.id) {
      this.setState({ ...this.state, tower: { ...props.tower, auto: 4 }});
    } else if(props.tower === null) { 
      this.setState({ ...this.state, tower: { ...this.tower, auto: 4 }});
    }
    
    if(props.model_id !== this.state.model_id) {
      this.tower = { ...this.tower, model_no: props.model_no, model_id: props.model_id, auto: 4  };
    }
    
    if(props.tower && props.tower.id !== this.state.tower.id) {
      this.setState({ ...this.state, tower: { ...props.tower, auto: 4 }});
    } else if(!props.tower) { 
      this.setState({ ...this.state, tower: { ...this.tower, auto: 4 }});
    }
  }

  onChange = (field, value) => {
    const tower = { ...this.state.tower };
    tower[field] = value;
    this.setState({ ...this.state, tower: { ...tower }});
  }

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    TowerAPI.saveTower(this.state.tower, this.onSaved, this.props.failure, this.props.logout);
  }

  onSaved = res => {
    Util.showNotification('Successful', 'Tower saved successfully', 'success');
    this.setState({ ...this.state, tower: { ...this.state.tower, id: res.id}, inApiCall: false });
    this.props.onHide();
    if(this.props.reload) {
      this.props.reload();
    }
  }

  render() {
    const fields = this.model.fields;
    const inValid = this.state.inValid;
    const tower = this.state.tower;
    
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false }>
        
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Towers</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form>
              <FieldText key="tower_name" id="tower_name" field={fields.tower_name}
                value={tower.tower_name} onValueChange={this.onChange} inValid={inValid} />
              { this.state.tower.id === 0 ?  
                <>
                  <FieldText key="total_floor" id="total_floor" field={fields.total_floor}
                    value={tower.total_floor} onValueChange={this.onChange} inValid={inValid} />
                  
                  <FieldText key="room_per_floor" id="room_per_floor" field={fields.room_per_floor}
                    value={tower.room_per_floor} onValueChange={this.onChange} inValid={inValid} />

                  <div className="col">
                    <div className="form-group">
                      <label>Auto Generated Room No Length</label>
                      <FormControl type="number" placeholder="Length" className="mr-sm-2"
                        value={tower.auto} onChange={event => this.onChange('auto', event.target.value)} />
                    </div>
                  </div>
                </>
                : null
              }  
            </Form>
          </ApiUiController>
        </Modal.Body>

        <Modal.Footer>
          <ApiUiController inApiCall={this.state.inApiCall}><Button onClick={this.onSave}>Submit</Button></ApiUiController>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default TowerPopup;